import ExternSearch from './ExternSearch';

export default ExternSearch;
